<template>
	<div class="content">
		<el-row type="flex" justify="space-around" align="middle" style="height: 90px;">
			<el-col :span="10"  style="display: flex;align-items: center;flex-direction: row;">
				<div style="display: flex;align-items: center;margin-right: 10px;"><el-image style="width: 70px; height: 70px" :src="require('../../static/logo.png')" fit="scale-down"></el-image></div>
				<div >
					<div class="mediue-font">襄阳人才双创大数据平台</div>
				</div>
			</el-col>
			<el-col :span="8">
				<!-- <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
				    <el-select v-model="select" slot="prepend" placeholder="请选择">
				      <el-option label="餐厅名" value="1"></el-option>
				      <el-option label="订单号" value="2"></el-option>
				      <el-option label="用户电话" value="3"></el-option>
				    </el-select>
				    <el-button slot="append" icon="el-icon-search"></el-button>
				</el-input> -->
			</el-col>
			<el-col :span="6" >
				<!-- <el-row type="flex" justify="end">
					<el-button type="primary" size="medium">免费发布需求</el-button>
					<el-button type="warning" size="medium">免费找官方推荐</el-button>
				</el-row> -->
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
  name: 's-header',
  data () {
	return {
	  select: '',
	  input3: '',
	}
  },
  mounted() {
  },
  methods:{
  },

}

</script>



// WEBPACK FOOTER //
// src/components/header.vue